<template>
  <div class="book">
    <div class="page left">
      <h1>五輪書の紹介</h1>
        <p>『五輪書』（ごりんのしょ）は、江戸時代初期の剣豪 <strong>宮本武蔵（みやもと むさし）</strong> によって書かれた兵法書です。1645年（正保2年）に執筆され、武蔵の死後に広まりました。この書は、武蔵が生涯をかけて培った <strong>「二天一流（にてんいちりゅう）」</strong> の剣術と戦略について述べたものであり、日本の武道や戦略論に大きな影響を与えました。</p>
        <h2>五つの巻</h2>
        <ul>
            <li><strong>地の巻（ちのまき）：</strong> 剣術の基礎や心構えについて説明。</li>
            <li><strong>水の巻（みずのまき）：</strong> 二天一流の剣術の具体的な技法を解説。</li>
            <li><strong>火の巻（ひのまき）：</strong> 実戦における戦略や攻撃の方法を詳述。</li>
            <li><strong>風の巻（かぜのまき）：</strong> 他流派の剣術と比較し、それぞれの特徴を分析。</li>
            <li><strong>空の巻（くうのまき）：</strong> 究極の境地として、無心・無我の精神を説く。</li>
        </ul>
        <p>武蔵はこの書の中で、「兵法とは単なる剣術ではなく、あらゆる戦いや人生に応用できる道である」と説いています。彼の哲学は現代の経営戦略や自己啓発にも影響を与え、多くのビジネスリーダーや武道家に研究されています。</p>
    </div>
    <div class="page right">
      <h2>《五轮书》介绍</h2>
        <p>《五轮书》是江户时代初期的剑豪 <strong>宫本武藏</strong> 所撰写的一部兵法书。它成书于1645年（正保二年），并在武藏去世后逐渐传播开来。本书总结了他一生所修炼的 <strong>“二天一流”</strong> 剑术和战略思想，对日本的武道和战略理论产生了深远影响。</p>
        
        <h2>五个篇章</h2>
        <ul>
            <li><strong>地之卷：</strong> 讲解剑术的基本理念和心态。</li>
            <li><strong>水之卷：</strong> 详细说明二天一流剑术的具体技巧。</li>
            <li><strong>火之卷：</strong> 探讨实战中的战略和攻击方法。</li>
            <li><strong>风之卷：</strong> 分析并比较其他流派的剑术特点。</li>
            <li><strong>空之卷：</strong> 阐述“无心、无我”的最高境界。</li>
        </ul>
        
        <p>武藏在书中强调：“兵法不仅仅是剑术，而是可以应用于任何战斗乃至人生的法则。”他的思想影响至今，被众多企业管理者和武道家研究，甚至被用于商业战略和个人成长领域。</p>
    </div>
  </div>
</template>

<style lang="scss">
@import "./fiveRingsCss.scss";
</style>

